import { EuiProvider, euiStylisPrefixer } from "@elastic/eui";
import createCache from "@emotion/cache";
import { RouterProvider } from "react-router-dom";
import "./App.css";

//css
import "@elastic/eui/dist/eui_theme_light.min.css";
import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import "@mantine/tiptap/styles.css";
import "@mantine/dates/styles.css"; //if using mantine date picker features
import "mantine-react-table/styles.css"; //import MRT styles
import "@mantine/charts/styles.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "react-toastify/dist/ReactToastify.css";
import router from "./_setup/router/routes";
import React, { useState } from "react";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { AuthProvider } from "./contexts/AuthContext";
import { TokenExpirationWarning } from "./components/TokenExpirationWarning/TokenExpirationWarning";

const container = document.querySelector('meta[name="emotion-styles"]');
const cache = createCache({
  key: "eui",
  container: container || undefined,
  stylisPlugins: [euiStylisPrefixer],
});
cache.compat = true;

function App() {
  const queryClient = new QueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <EuiProvider cache={cache}>
        <AuthProvider>
          <TokenExpirationWarning />
          <RouterProvider router={router} />
        </AuthProvider>
      </EuiProvider>
    </QueryClientProvider>
  );
}

export default App;
